import React, { useState, useEffect, useRef } from "react";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { useNavigate } from "react-router";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography
} from "@mui/material";
import { toast } from "react-toastify";
import moment from "moment";

import {
  getApiWithAuth,
  postApiWithAuth,
  patchApiWithAuth,
} from "../utils/api";
import {
  SEND_TWILIO_SMS,
  TWILIO_SMS_LIST,
  ORDER_CHAT_LIST,
  TWILIO_UNREAD_SMS_COUNT,
  CONTACT,
  CONTACT_UNREAD_SMS,
  CONTACT_MARK_READ,
} from "../utils/apiUrl";
import ChatHeader from "../components/ChatPageCompo/ChatHeader";
import TwilioChatCard from "../components/ChatPageCompo/TwilioChatCard";
import TwilioChatComponent from "../components/ChatPageCompo/TwilioChatComponent";
import { PhoneNumberField } from "../components/Ui/PhoneNumberField";

const TwilioChatPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [unreadCounts, setUnreadCounts] = useState({});
  const [smsList, setSMSList] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [contactDetail, setContactDetail] = useState([]);
  const [smsId, setSMSId] = useState("");
  const [search, setSearch] = useState("");
  const [text, setText] = useState("");
  const [targetLanguage, setTargetLanguage] = useState("es");
  const [translatedText, setTranslatedText] = useState("");
  const [isTranslating, setIsTranslating] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [newName, setNewName] = useState("");
  const [newPhone, setNewPhone] = useState("");
  const [address, setAddress] = useState("");

  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    address: "",
  });


  const [dateRange, setDateRange] = useState([
    new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000),
    new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000),
  ]);

  const chatContainerRef = useRef(null);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    if (smsList) {
      scrollToBottom();
    }
  }, [smsList]);


  const handleTicketClick = async (smsId) => {
    setSMSId(smsId);
    await markReadOrderChat(smsId);
    await fetchSMS(smsId);
    // await fetchContacts()
    markReadOrderChat(smsId);
  };


  const fetchContacts = async () => {
    const response = await getApiWithAuth(CONTACT);
    const data = response.data.data
    console.log(data[0]?.id)
    await fetchSMS(data[0]?.id)
    setContacts(data);
  }

  const fetchSMS = async (id) => {
    const response = await getApiWithAuth(`${CONTACT}${id}/personal-sms/`);
    const data = response.data.data
    setSMSList(data)
  }

  const fetchUnreadSmsCount = async () => {
    const response = await getApiWithAuth(CONTACT_UNREAD_SMS);
    const data = response.data.data;
    setUnreadCounts(data?.unread_counts);
  };

  useEffect(() => {
    // Initialize WebSocket connection
    const unreadSMSClient = new W3CWebSocket(
      "wss://testadmin.pilldrop.ai/ws/unread_sms/"
    );

    // Handle connection open
    unreadSMSClient.onopen = () => {
      console.log("WebSocket connection established for unread SMS counts");
    };

    // Handle incoming messages
    unreadSMSClient.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        if (data.type === "unread_sms_counts") {
          const counts = data.data;
          const { total_unread_count, unread_counts } = counts;

          // Update the state with new counts
          // setTotalUnreadCount(total_unread_count);
          // setUnreadCountsByOrder(unread_counts);

          setUnreadCounts(unread_counts);
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    // Handle connection close
    unreadSMSClient.onclose = () => {
      console.log("WebSocket connection closed for unread SMS counts");
      // Optionally, implement reconnection logic here
    };

    // Handle errors
    unreadSMSClient.onerror = (error) => {
      console.error("WebSocket error for unread SMS counts:", error);
    };

    // Cleanup function to close WebSocket connection when component unmounts
    return () => {
      unreadSMSClient.close();
    };
  }, []);

  const markReadOrderChat = async (smsId) => {
    await postApiWithAuth(`${CONTACT}${smsId}/mark-personal-read/`);
    fetchUnreadSmsCount();
  };

  useEffect(() => {
    fetchContacts();
  }, [search, dateRange]);

  useEffect(() => {
    fetchUnreadSmsCount();
  }, []);

  const handleSendTwilioSms = async () => {
    if (smsId !== "") {
      setLoading(true);
      const payload = translatedText !== "" ? {
        to_number: contactDetail?.number,
        text: text,
        isPersonal: true,
        translatedText,
        targetLanguage
      } : {
        to_number: contactDetail?.number,
        text: text,
        isPersonal: true,
        targetLanguage: "",
        translatedText: ""
      }

      const response = await postApiWithAuth(SEND_TWILIO_SMS, payload);
      if (response.data.error === undefined) {
        toast.success(response.data.data.message, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        toast.error(response.data.error, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      setText("");
    } else {
      console.log("Add number to send sms");
    }

    setText("");
    setTranslatedText("");
    setIsTranslating(false);
    setTargetLanguage("es")
    fetchSMS(smsId)
    setLoading(false);
  };

  const handleCardClick = (cardId) => {
    setActiveCard(cardId);
  };

  const handleOpenAdd = () => {
    console.log("ddd")
    setOpenAddModal(true)
  };
  const handleCloseAdd = () => {
    setOpenAddModal(false);
    setNewName("");
    setNewPhone("");
    setAddress("");
    setErrors({ name: "", phone: "", address: "" });
  };

  const validate = () => {
    const errs = { name: "", phone: "", address: "" };
    if (!newName.trim()) errs.name = "Name is required";
    if (!newPhone.trim()) errs.phone = "Phone is required";
    if (!address.trim()) {
      errs.address = "address is required";
    }
    setErrors(errs);
    return !errs.name && !errs.phone && !errs.address;
  };

  const handleSaveNew = async () => {
    if (!validate()) return;

    const payload = {
      name: newName.trim(),
      address: address.trim(),
      number: newPhone.trim(),
      pharmacy: Number(localStorage.getItem("pharmacyId") || 0),
    };

    console.log("Submitting payload:", payload);

    try {
      const response = await postApiWithAuth(CONTACT, payload);
      console.log("API response:", response);
    } catch (err) {
      console.error("API error:", err);
    }

    fetchContacts();

    handleCloseAdd();
  };

  // Save button enabled only when all fields non-empty and address format OK
  const isSaveEnabled =
    newName.trim() &&
    newPhone.trim() &&
    address.trim();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {/* <Topbar /> */}

      <ChatHeader
        dateRange={dateRange}
        setDateRange={setDateRange}
        setSearch={setSearch}
        onAddNewClick={handleOpenAdd}
      />
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            maxHeight: "80vh",
            overflowY: "auto",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "10px",
              border: "2px solid transparent",
              backgroundClip: "content-box",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-track:hover": {
              backgroundColor: "#e1e1e1",
            },
          }}
        >
          {contacts &&
            contacts.map((contact, i) => (
              <Box
                display="flex"
                minWidth="350px"
                backgroundColor="#EBEBEC"
                borderRadius="12px"
                flexDirection="column"
                onClick={() => {
                  handleTicketClick(contact.id);
                  setContactDetail(contact);
                }}
                key={i}
              >
                <TwilioChatCard
                  key={i}
                  chat={contact}
                  unreadCounts={unreadCounts[contact.id] || 0}
                  onClick={() => handleCardClick(contact.id)}
                  isActive={activeCard === contact.id}
                />
              </Box>
            ))}
        </Box>
        <Box
          sx={{ flex: 3, paddingX: 2, maxHeight: "80vh", overflowY: "auto" }}
        >
          {smsList !== undefined && (
            <TwilioChatComponent
              contactDetail={contactDetail}
              chatDetail={smsList}
              handleSendTwilioSms={handleSendTwilioSms}
              text={text}
              setText={setText}
              setTargetLanguage={setTargetLanguage}
              targetLanguage={targetLanguage}
              translatedText={translatedText}
              setTranslatedText={setTranslatedText}
              isTranslating={isTranslating}
              setIsTranslating={setIsTranslating}
            />
          )}
        </Box>
      </Box>

      <Dialog open={openAddModal} onClose={handleCloseAdd}>
        <DialogTitle>Add New Contact</DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>

          <Box sx={{ flex: 3 }}>
            <Typography
              variant="h1"
              sx={{ fontSize: "12px", fontWeight: 600, marginBottom: "3px" }}
            >
              Name
            </Typography>
            <TextField
              autoComplete="off"
              name="name"
              placeholder="Name"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              error={!!errors.name}
              helperText={errors.name}
              type="text"
              sx={{
                width: "100%",
                "& .MuiInputBase-input": {
                  fontSize: "11px",
                  padding: "8px 12px",
                },
                "& .MuiOutlinedInput-root": {
                  height: "36px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "11px",
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#4b5563",
                },
              }}
            />
          </Box>
          <PhoneNumberField
            label="Phone Number"
            value={newPhone}
            onChange={(value) => setNewPhone(value)}
            placeholder="(675) 454-2724"
            height="32px"
            width="237px"
            error={!!errors.phone}
            helperText={errors.phone}
          />

          <Box sx={{ flex: 3 }}>
            <Typography
              variant="h1"
              sx={{ fontSize: "12px", fontWeight: 600, marginBottom: "3px" }}
            >
              address
            </Typography>
            <TextField
              autoComplete="off"
              placeholder="Address"
              name="address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              error={!!errors.address}
              helperText={errors.address}
              type="address"
              sx={{
                width: "100%",
                "& .MuiInputBase-input": {
                  fontSize: "11px",
                  padding: "8px 12px",
                },
                "& .MuiOutlinedInput-root": {
                  height: "36px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "11px",
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#4b5563",
                },
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAdd}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleSaveNew}
            disabled={!isSaveEnabled}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TwilioChatPage;
